import type { Abi } from "viem";

export const factoryAbi = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": false, "internalType": "uint256", "name": "previousFeeBps", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "newFeeBps", "type": "uint256" }
    ],
    "name": "FeeBpsUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "indexed": false, "internalType": "string", "name": "question", "type": "string" },
      { "indexed": false, "internalType": "string", "name": "resolutionSource", "type": "string" },
      { "indexed": false, "internalType": "uint256", "name": "deadline", "type": "uint256" },
      { "indexed": true, "internalType": "address", "name": "creator", "type": "address" },
      { "indexed": false, "internalType": "uint256", "name": "virtualLiquidity", "type": "uint256" }
    ],
    "name": "MarketCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "indexed": false, "internalType": "bool", "name": "outcome", "type": "bool" },
      { "indexed": false, "internalType": "string", "name": "evidenceUrl", "type": "string" },
      { "indexed": false, "internalType": "string", "name": "notes", "type": "string" },
      { "indexed": true, "internalType": "address", "name": "resolver", "type": "address" },
      { "indexed": false, "internalType": "uint256", "name": "resolvedAt", "type": "uint256" }
    ],
    "name": "MarketResolved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "yesSeed", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "noSeed", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "yesSharesMinted", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "noSharesMinted", "type": "uint256" }
    ],
    "name": "MarketSeeded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" },
      { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "indexed": true, "internalType": "address", "name": "buyer", "type": "address" },
      { "indexed": true, "internalType": "bool", "name": "isYes", "type": "bool" },
      { "indexed": false, "internalType": "uint256", "name": "amountIn", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "feeAmount", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "netAmountIn", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "sharesOut", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "avgPriceBps", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "newYesPool", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "newNoPool", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "newYesPriceBps", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "newNoPriceBps", "type": "uint256" }
    ],
    "name": "SharesBought",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "indexed": true, "internalType": "address", "name": "seller", "type": "address" },
      { "indexed": true, "internalType": "bool", "name": "isYes", "type": "bool" },
      { "indexed": false, "internalType": "uint256", "name": "sharesIn", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "grossAmountOut", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "feeAmount", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "netAmountOut", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "avgPriceBps", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "newYesPriceBps", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "newNoPriceBps", "type": "uint256" }
    ],
    "name": "SharesSold",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "previousTreasury", "type": "address" },
      { "indexed": true, "internalType": "address", "name": "newTreasury", "type": "address" }
    ],
    "name": "TreasuryUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "indexed": true, "internalType": "address", "name": "user", "type": "address" },
      { "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" }
    ],
    "name": "WinningsClaimed",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "DEFAULT_VIRTUAL_LIQUIDITY",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "internalType": "bool", "name": "isYes", "type": "bool" }
    ],
    "name": "buyShares",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "marketId", "type": "uint256" }],
    "name": "claimWinnings",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" },
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "name": "claimed",
    "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "string", "name": "question", "type": "string" },
      { "internalType": "string", "name": "resolutionSource", "type": "string" },
      { "internalType": "uint256", "name": "durationMinutes", "type": "uint256" }
    ],
    "name": "createMarket",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "string", "name": "question", "type": "string" },
      { "internalType": "string", "name": "resolutionSource", "type": "string" },
      { "internalType": "uint256", "name": "durationMinutes", "type": "uint256" },
      { "internalType": "uint256", "name": "virtualLiquidity", "type": "uint256" }
    ],
    "name": "createMarketWithLiquidity",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "string", "name": "question", "type": "string" },
      { "internalType": "string", "name": "resolutionSource", "type": "string" },
      { "internalType": "uint256", "name": "durationMinutes", "type": "uint256" },
      { "internalType": "uint256", "name": "yesSeedAmount", "type": "uint256" },
      { "internalType": "uint256", "name": "noSeedAmount", "type": "uint256" }
    ],
    "name": "createSeededMarket",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "string", "name": "question", "type": "string" },
      { "internalType": "string", "name": "resolutionSource", "type": "string" },
      { "internalType": "uint256", "name": "durationMinutes", "type": "uint256" },
      { "internalType": "uint256", "name": "virtualLiquidity", "type": "uint256" },
      { "internalType": "uint256", "name": "yesSeedAmount", "type": "uint256" },
      { "internalType": "uint256", "name": "noSeedAmount", "type": "uint256" }
    ],
    "name": "createSeededMarketWithLiquidity",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "feeBps",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getActiveMarketIds",
    "outputs": [{ "internalType": "uint256[]", "name": "", "type": "uint256[]" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "marketId", "type": "uint256" }],
    "name": "getMarket",
    "outputs": [
      { "internalType": "uint256", "name": "id", "type": "uint256" },
      { "internalType": "string", "name": "question", "type": "string" },
      { "internalType": "string", "name": "resolutionSource", "type": "string" },
      { "internalType": "uint256", "name": "deadline", "type": "uint256" },
      { "internalType": "address", "name": "creator", "type": "address" },
      { "internalType": "bool", "name": "resolved", "type": "bool" },
      { "internalType": "bool", "name": "outcome", "type": "bool" },
      { "internalType": "uint256", "name": "yesPool", "type": "uint256" },
      { "internalType": "uint256", "name": "noPool", "type": "uint256" },
      { "internalType": "uint256", "name": "totalYesShares", "type": "uint256" },
      { "internalType": "uint256", "name": "totalNoShares", "type": "uint256" },
      { "internalType": "uint256", "name": "virtualLiquidity", "type": "uint256" },
      { "internalType": "string", "name": "resolutionEvidenceUrl", "type": "string" },
      { "internalType": "string", "name": "resolutionNotes", "type": "string" },
      { "internalType": "address", "name": "resolver", "type": "address" },
      { "internalType": "uint256", "name": "resolvedAt", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "marketId", "type": "uint256" }],
    "name": "getPrices",
    "outputs": [
      { "internalType": "uint256", "name": "yesPriceBps", "type": "uint256" },
      { "internalType": "uint256", "name": "noPriceBps", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "internalType": "address", "name": "user", "type": "address" }
    ],
    "name": "getUserCostBasis",
    "outputs": [
      { "internalType": "uint256", "name": "yesCost", "type": "uint256" },
      { "internalType": "uint256", "name": "noCost", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "internalType": "address", "name": "user", "type": "address" }
    ],
    "name": "getUserPosition",
    "outputs": [
      { "internalType": "uint256", "name": "yesAmount", "type": "uint256" },
      { "internalType": "uint256", "name": "noAmount", "type": "uint256" },
      { "internalType": "bool", "name": "alreadyClaimed", "type": "bool" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "name": "markets",
    "outputs": [
      { "internalType": "uint256", "name": "id", "type": "uint256" },
      { "internalType": "string", "name": "question", "type": "string" },
      { "internalType": "string", "name": "resolutionSource", "type": "string" },
      { "internalType": "uint256", "name": "deadline", "type": "uint256" },
      { "internalType": "address", "name": "creator", "type": "address" },
      { "internalType": "bool", "name": "resolved", "type": "bool" },
      { "internalType": "bool", "name": "outcome", "type": "bool" },
      { "internalType": "uint256", "name": "yesPool", "type": "uint256" },
      { "internalType": "uint256", "name": "noPool", "type": "uint256" },
      { "internalType": "uint256", "name": "totalYesShares", "type": "uint256" },
      { "internalType": "uint256", "name": "totalNoShares", "type": "uint256" },
      { "internalType": "uint256", "name": "virtualLiquidity", "type": "uint256" },
      { "internalType": "string", "name": "resolutionEvidenceUrl", "type": "string" },
      { "internalType": "string", "name": "resolutionNotes", "type": "string" },
      { "internalType": "address", "name": "resolver", "type": "address" },
      { "internalType": "uint256", "name": "resolvedAt", "type": "uint256" },
      { "internalType": "bool", "name": "exists", "type": "bool" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "nextMarketId",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" },
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "name": "noCostBasis",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" },
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "name": "noShares",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "internalType": "bool", "name": "isYes", "type": "bool" },
      { "internalType": "uint256", "name": "amountIn", "type": "uint256" }
    ],
    "name": "previewBuy",
    "outputs": [
      { "internalType": "uint256", "name": "sharesOut", "type": "uint256" },
      { "internalType": "uint256", "name": "avgPriceBps", "type": "uint256" },
      { "internalType": "uint256", "name": "newYesPriceBps", "type": "uint256" },
      { "internalType": "uint256", "name": "newNoPriceBps", "type": "uint256" },
      { "internalType": "uint256", "name": "estimatedPayoutIfWins", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "internalType": "bool", "name": "isYes", "type": "bool" },
      { "internalType": "uint256", "name": "sharesIn", "type": "uint256" }
    ],
    "name": "previewSell",
    "outputs": [
      { "internalType": "uint256", "name": "grossAmountOut", "type": "uint256" },
      { "internalType": "uint256", "name": "feeAmount", "type": "uint256" },
      { "internalType": "uint256", "name": "netAmountOut", "type": "uint256" },
      { "internalType": "uint256", "name": "avgPriceBps", "type": "uint256" },
      { "internalType": "uint256", "name": "newYesPriceBps", "type": "uint256" },
      { "internalType": "uint256", "name": "newNoPriceBps", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "internalType": "bool", "name": "outcome", "type": "bool" },
      { "internalType": "string", "name": "evidenceUrl", "type": "string" },
      { "internalType": "string", "name": "notes", "type": "string" }
    ],
    "name": "resolveMarket",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "marketId", "type": "uint256" },
      { "internalType": "bool", "name": "isYes", "type": "bool" },
      { "internalType": "uint256", "name": "sharesIn", "type": "uint256" }
    ],
    "name": "sellShares",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "newFeeBps", "type": "uint256" }],
    "name": "setFeeBps",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "address", "name": "newTreasury", "type": "address" }],
    "name": "setTreasury",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "treasury",
    "outputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" },
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "name": "yesCostBasis",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" },
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "name": "yesShares",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
] as const satisfies Abi;